@if(view=== 'impacted-testcase-analysis'){ @if(!loading) {
<div
  *ngIf="accordionItems.length"
  class="container-fluid recommendations h-100 mt-4 mb-4 d-flex flex-column"
>
  <span class="header-4 pb-3">
    # of Impacted Test Cases : {{ impactedFileCount }}
  </span>
  <span class="header-4">
    # Modified Code File: : {{ modifiedFileCount }}
  </span>
  <div class="mt-3">
    <app-accordion [accordionData]="accordionItems"></app-accordion>
  </div>
</div>

<div [hidden]="accordionItems.length">
  <app-no-data></app-no-data>
</div>

} @else {
<app-loading [text]="'Loading data'"></app-loading>
} } @else { @if(!loading) {

<div
  *ngIf="tableData?.data.length"
  class="container-fluid recommendations h-100 mt-4 mb-4 d-flex flex-column"
>
  <div class="reusable-wrapper">
    <app-zorro-table
      tableId="imp-tc-analysis"
      [data]="tableData?.data"
      [columns]="tableData?.columns"
      (handleActions)="handleTableActions($event)"
    ></app-zorro-table>
  </div>
</div>
<div [hidden]="tableData?.data.length">
  <app-no-data></app-no-data>
</div>
} @else {
<app-loading [text]="'Loading data'"></app-loading>
} }
